// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wraper":"wraper_itkCM","zoom":"zoom_L3MFQ","zoom__item":"zoom__item_zKmER","zoom__item__icon":"zoom__item__icon_hJEcJ","ui_mask":"ui_mask_Lx9Qf"};